import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@app/environments/environment';
import { Observable } from 'rxjs';
import { ApiService } from '../api.service';

export interface IRegionWorkplace {
  id?: string;
  region: string;
  title?: string;
  link: string;
  imagepath?: string;
  thumbnailpath: string;
}

@Injectable({
  providedIn: 'root'
})
export class RegionWorkplaceService extends ApiService {
  constructor(httpClient: HttpClient) {
    super(httpClient);
  }

  regionWorkplace$ = this.get<IRegionWorkplace[]>(`${environment.DEPS.ADMIN_API.URL}/cms/regionandworkplace`);

  saveRegionWorkplace(region: IRegionWorkplace): Observable<void> {
    return this.put(`${environment.DEPS.ADMIN_API.URL}/cms/regionandworkplace`, region);
  }

  deleteRegionWorkplace(title: string): Observable<void> {
    return this.delete(`${environment.DEPS.ADMIN_API.URL}/cms/regionandworkplace/delete?title=${title}`);
  }
}
